import { UPCOMING_MATCH_LIST_SUCCESS, UPCOMING_MATCH_LIST_ERROR, IS_LOADING, ACTIVE_MATCH_LIST_SUCCESS, ACTIVE_MATCH_LIST_ERROR, POOL_LIST_ERROR, POOL_LIST_SUCCESS, MATCH_STATUS_CHANGED_ERROR, MATCH_STATUS_CHANGED_SUCCESS, POOL_ADD_SUCCESS, POOL_ADD_ERROR, POOL_PRIZE_BREAK_SUCCESS, POOL_PRIZE_BREAK_ERROR, POOL_STATUS_CHANGED_SUCCESS, POOL_STATUS_CHANGED_ERROR, ACTIVE_MATCH_POOL_LIST_SUCCESS, ACTIVE_MATCH_POOL_LIST_ERROR, PUBLISH_MATCH_POOL_SUCCESS, PUBLISH_MATCH_POOL_ERROR, UPCOMING_SERIES_LIST_SUCCESS, UPCOMING_SERIES_LIST_ERROR, ACTIVE_SERIES_LIST_SUCCESS, ACTIVE_SERIES_LIST_ERROR, SERIES_ACTION_SUCCESS, SERIES_ACTION_ERROR, ACTIVE_INC_MATCH_POOL_SUCESS, ACTIVE_INC_MATCH_POOL_ERROR, } from "../actions/Type";

const initialState = {
    upcoming_match_list: {},
    active_match_list: {},
    pool_list: {},
    pool_add: {},
    match_status: {},
    pool_status: {},
    prize_break: {},
    active_pool_list: {},
    upcoming_series_list: {},
    series_action: {},
    active_series_list: {},
    activeincpooldata: {},
    match_publish: {},
    loading: false,

}

const MatchReducers = (state = initialState, { type, payload } = {}) => {
    switch (type) {
        case IS_LOADING:
            return {
                ...state,
                loading: true
            }
        case UPCOMING_MATCH_LIST_SUCCESS:
            return {
                ...state,
                upcoming_match_list: payload,
                loading: false
            }

        case UPCOMING_MATCH_LIST_ERROR:
            return {
                ...state,
                upcoming_match_list: payload,
                loading: false
            }

        case PUBLISH_MATCH_POOL_SUCCESS:
            return {
                ...state,
                match_publish: payload,
                loading: false
            }
        case PUBLISH_MATCH_POOL_ERROR:
            return {
                ...state,
                match_publish: payload,
                loading: false
            }
        case ACTIVE_MATCH_LIST_SUCCESS:
            return {
                ...state,
                active_match_list: payload,
                loading: false
            }

        case ACTIVE_MATCH_LIST_ERROR:
            return {
                ...state,
                active_match_list: payload,
                loading: false
            }
        case POOL_LIST_SUCCESS:
            return {
                ...state,
                pool_list: payload,
                loading: false
            }

        case POOL_LIST_ERROR:
            return {
                ...state,
                pool_list: payload,
                loading: false
            }

        case POOL_ADD_SUCCESS:
            return {
                ...state,
                pool_add: payload,
                loading: false
            }

        case POOL_ADD_ERROR:
            return {
                ...state,
                pool_add: payload,
                loading: false
            }

        case POOL_STATUS_CHANGED_SUCCESS:
            return {
                ...state,
                pool_status: payload,
                loading: false
            }

        case POOL_STATUS_CHANGED_ERROR:
            return {
                ...state,
                pool_status: payload,
                loading: false
            }
        case MATCH_STATUS_CHANGED_SUCCESS:
            return {
                ...state,
                match_status: payload,
                loading: false
            }

        case MATCH_STATUS_CHANGED_ERROR:
            return {
                ...state,
                match_status: payload,
                loading: false
            }

        case POOL_PRIZE_BREAK_SUCCESS:
            return {
                ...state,
                prize_break: payload,
                loading: false
            }

        case POOL_PRIZE_BREAK_ERROR:
            return {
                ...state,
                prize_break: payload,
                loading: false
            }

        case ACTIVE_MATCH_POOL_LIST_SUCCESS:
            return {
                ...state,
                active_pool_list: payload,
                loading: false
            }

        case ACTIVE_MATCH_POOL_LIST_ERROR:
            return {
                ...state,
                active_pool_list: payload,
                loading: false
            }


        case UPCOMING_SERIES_LIST_SUCCESS:
            return {
                ...state,
                upcoming_series_list: payload,
                loading: false
            }

        case UPCOMING_SERIES_LIST_ERROR:
            return {
                ...state,
                upcoming_series_list: payload,
                loading: false
            }

        case ACTIVE_SERIES_LIST_SUCCESS:
            return {
                ...state,
                active_series_list: payload,
                loading: false
            }

        case ACTIVE_SERIES_LIST_ERROR:
            return {
                ...state,
                active_series_list: payload,
                loading: false
            }

        case SERIES_ACTION_SUCCESS:
            return {
                ...state,
                series_action: payload,
                loading: false
            }

        case SERIES_ACTION_ERROR:
            return {
                ...state,
                series_action: payload,
                loading: false
            }

        case ACTIVE_INC_MATCH_POOL_SUCESS:
            return {
                ...state,
                activeincpooldata: payload,
                loading: false
            }

        case ACTIVE_INC_MATCH_POOL_ERROR:
            return {
                ...state,
                activeincpooldata: payload,
                loading: false
            }


        default:
            return state
    }
}

export default MatchReducers